<script setup>
import { ref } from "vue"
import Header from "@/js/partials/installer/Header.vue"
import Footer from "@/js/partials/Footer.vue"
import AuthenticationModal from "@/js/partials/installer/AuthenticationModal.vue"
const dialogs = ref({
  authenticationModal: {
    toggle: false,
    mode: "sign-up",
  },
})
const toggleSignIn = () => {
  dialogs.value.authenticationModal.mode = "sign-in"
  dialogs.value.authenticationModal.toggle = true
}
const toggleSignUp = () => {
  dialogs.value.authenticationModal.mode = "sign-up"
  dialogs.value.authenticationModal.toggle = true
}
</script>

<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <!-- Site header -->
    <Header @sign-up="toggleSignUp" @sign-in="toggleSignIn" />
    <!-- Page content -->
    <main class="grow">
      <AuthenticationModal v-model="dialogs.authenticationModal" />
      <!-- Page sections -->
      <router-view @sign-up="toggleSignUp"></router-view>
    </main>

    <!-- Site footer -->
    <Footer />
  </div>
</template>
